import { Mail } from 'lucide-react';

const FONT_H = { fontFamily: "'Outfit', sans-serif" };
const FONT_B = { fontFamily: "'Manrope', sans-serif" };
const GRADIENT_BG = 'linear-gradient(135deg, #E91E8C 0%, #6C3CE0 100%)';

export function UnconfirmedInboxView({ email, resending, onResend, onBack }) {
  return (
    <div data-testid="auth-unconfirmed-view">
      <div className="w-14 h-14 rounded-2xl flex items-center justify-center mb-5" style={{ background: GRADIENT_BG }}>
        <Mail className="w-7 h-7 text-white" />
      </div>
      <h1 className="text-2xl sm:text-3xl font-extrabold tracking-tight mb-2 text-gray-900" style={FONT_H}>Check your inbox</h1>
      <p className="text-gray-500 text-sm mb-6" style={FONT_B}>
        We sent a confirmation link to <span className="font-semibold text-gray-800">{email}</span>.
        Click the link in the email to activate your account. The link expires in 48 hours.
      </p>
      <div className="bg-amber-50 border border-amber-200 rounded-xl p-3.5 text-xs text-amber-800 mb-5" style={FONT_B}>
        Didn&apos;t receive it? Check your spam folder, or ask the platform admin to confirm your account manually while we finish setting up our sender domain.
      </div>
      <div className="space-y-3">
        <button type="button" onClick={onResend} disabled={resending}
          className="w-full rounded-xl font-bold py-3 text-white text-sm transition-all hover:opacity-90 disabled:opacity-50"
          style={{ ...FONT_B, background: GRADIENT_BG }}
          data-testid="auth-resend-confirmation">
          {resending ? 'Sending…' : 'Resend confirmation email'}
        </button>
        <button type="button" onClick={onBack}
          className="w-full rounded-xl font-semibold py-3 text-sm border border-gray-200 bg-white text-gray-700 hover:bg-gray-50 transition-colors"
          style={FONT_B}
          data-testid="auth-unconfirmed-back">
          Back to sign in
        </button>
      </div>
    </div>
  );
}
